import { useState } from "react";
import Select from "react-select";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { optionSelector } from "../../../config/apiSPA";

function EditLocation({ show, onHide, data, submitClick }) {
  const [val, setVal] = useState("");
  const [locationList, setLocationList] = useState([]);

  function handleChangeLocation(val) {
    setVal(val.value);
  }
  function handleShow() {
    setVal("");
    optionSelector(`/location`).then((res) => setLocationList(res));
  }
  return (
    <>
      <Modal show={show} onShow={handleShow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Edit Training Location</h5>
        </ModalHeader>
        <ModalBody>
          <Select onChange={(val) => handleChangeLocation(val)} options={locationList} isSearchable classNamePrefix="react-select" />
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submitClick({ id: data.id, label: "location", val: val })} type="button" className="btn btn-outline-theme" disabled={val ? false : true}>
            Save
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default EditLocation;
